import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';

import { getShop } from '../../shared/selectors';

export default id => state =>
  id ? `#${id}-${kebabCase(get(getShop(id)(state), 'name', ''))}` : '#';
